import React from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    hiredLabel: {
        color: theme.palette.yellow[800],
        fontSize: 12,
        fontWeight: 700,
        background: theme.palette.yellow[200],
        borderRadius: 4,
        padding: '4px 14px',
        marginRight: 5
    }
}));

const HiredLabel = ({ className }) => {
    const { hiredLabel } = useStyles();

    return (
        <span className={clsx(hiredLabel, className)}>Hired</span>
    );
};

export default HiredLabel;
